import React from 'react'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { NumberInput } from '../../ui-lib/input/number-input'
import { FontSizeIcon } from 'src/editor/shared/icons/font-size-icon'

interface FontSizeControlProps {
  fontSize: number | undefined
  mobileFontSize?: number | undefined
  update: (value: number) => void
  mobileUpdate?: (value: number) => void
  className?: string
}

export const FontSizeControl = ({
  fontSize,
  mobileFontSize,
  mobileUpdate,
  update,
  className,
}: FontSizeControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultFontSize = (
    isMobile ? mobileFontSize || fontSize : fontSize
  ) as number

  const onChange = (value: number) => {
    isMobile ? mobileUpdate?.(value) : update?.(value)
  }

  return (
    <NumberInput
      value={resultFontSize}
      onChange={onChange}
      min={8}
      startElement={<FontSizeIcon />}
      className={className}
    />
  )
}
